
import React, { useRef, useState } from 'react';

import { amountFormatUse, getToken, local_utc_timestamp, utc_local } from '../../../helpers/Helper';
import { GET_EMPLOYEES_LIST, POST_SALARY_REPORTS, POST_SALARY_REPORTS_PRINT, POST_ADD_EDIT_PAYMENT } from '../../../helpers/url_helper';
import ReactDOM from 'react-dom/client';
import useMounted from '../../../hooks/useMounted';
import Loader from '../../../components/Loader';
import { useNavigate } from 'react-router-dom';
import SimpleReactValidator from 'simple-react-validator';

import $ from 'jquery';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/dataTables.dataTables.css";

import { useTranslation } from 'react-i18next';
import { get, post } from '../../../helpers/api_helper';
import { toast } from 'react-toastify';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import Select from 'react-select';

const SalaryReports = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [employees, setEmployees] = useState([]);
    const [isLoader, setLoader] = useState(0);

    const simpleValidator = useRef(new SimpleReactValidator());
    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [form_inputs, setInputs] = useState({ paymentId: 0, employeeId: '', date: local_utc_timestamp(new Date()), paymentType: '', paymentMethod: '', note: '', amount: '' });
    const [, forceUpdate] = useState();

    const [filter_option, setFilterOption] = useState({
        startDate: local_utc_timestamp(new Date(new Date().getFullYear(), new Date().getMonth(), 1)),
        endDate: local_utc_timestamp(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)),
        employeeId: '',
    });


    useMounted(() => {
        getList();
        get_employees();
    })

    const get_employees = async () => {
        var api_res = await get(GET_EMPLOYEES_LIST);
        if (api_res.status) {
            setEmployees(api_res.data.employees.map(employee => ({
                value: employee.employeeId,
                label: `${employee.name} (E-${employee.employeeId})`
            })));
        } else {
            toast.error(api_res.message);
        }
    }

    const getList = () => {
        const tableElement = $('#dataTableExample');
        if (tableElement.length > 0) {
            tableElement.DataTable({
                destroy: true,
                "bProcessing": true,
                "bServerSide": true,
                'searching': true,
                'stateSave': true,
                "scrollX": false,
                "sServerMethod": "POST",
                "order": [[4, 'desc']],
                columnDefs: [
                    { orderable: false, targets: [8] },
                    { "targets": 0, "visible": false }
                ],
                "ajax": function (data, callback, settings) {
                    data.sSearch = data.search.value;
                    data.iDisplayLength = data.length;
                    data.iDisplayStart = data.start;
                    data.sSortDir_0 = (data.order.length > 0) ? data.order[0].dir : '';
                    data.iSortCol_0 = (data.order.length > 0) ? data.order[0].column : '';
                    data.startDate = filter_option.startDate;
                    data.endDate = filter_option.endDate;
                    data.employeeId = filter_option.employeeId;

                    $.ajax({
                        "url": POST_SALARY_REPORTS,
                        "type": "POST",
                        "data": data,
                        "headers": { 'Authorization': getToken() },
                        "error": function (xhr, status, error) {
                            if (xhr.status === 401) {
                                navigate("/logout");
                            }
                        },
                        "success": callback
                    });
                },
                "columns": [
                    { "data": "salaryId" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>E-{data.employeeId}</>)
                        }
                    },
                    { "data": "name" },
                    { "data": "departmentName" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {utc_local(data.endDate, 'MMM, YYYY')}
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>{amountFormatUse(data.salary)}</>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>{amountFormatUse(data.overtimeSalary)}</>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>{amountFormatUse(data.totalAmount)}</>)
                        }
                    },

                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                <button className="btn btn-sm text-success" onClick={() => { print(data.salaryId, false) }} ><i className="bx bx-printer align-middle"></i></button>
                                <button className="btn btn-sm text-warning" onClick={() => { print(data.salaryId, true) }} ><i className="bx bxs-file-pdf "></i></button>
                                {data.isPay <= 0 && <button className="border-0 badge bg-info" onClick={() => {
                                    setInputs({
                                        paymentId: 0,
                                        salaryId: data.salaryId,
                                        employeeId: data.employeeId,
                                        date: local_utc_timestamp(new Date()),
                                        paymentType: 'Salary',
                                        paymentMethod: '',
                                        note: '',
                                        amount: ''
                                    });

                                }} data-bs-toggle="modal" data-bs-target="#deleteModal">Pay</button>}
                            </>)
                        }
                    },

                ]
            });
        }
    }

    // input text change handler
    const handleInputChangeFilter = (event) => {
        filter_option[event.target.name] = event.target.value;
        setFilterOption({ ...filter_option });
    }

    const clear = () => {
        filter_option.startDate = local_utc_timestamp(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
        filter_option.endDate = local_utc_timestamp(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0));
        filter_option.employeeId = '';

        setFilterOption({ ...filter_option });
        getList();
    }

    const [pdfUrl, setPdfUrl] = useState("");
    const print = (id, isPdf) => {
        const fetchPdf = async () => {
            setLoader(1);
            const response = await fetch(`${POST_SALARY_REPORTS_PRINT}?id=${id}&offset=${-new Date().getTimezoneOffset()}&isPdf=${isPdf}`, {
                method: "GET",
                headers: {
                    Authorization: `${getToken()}`,
                    "Content-Type": "application/pdf",
                },
            });
            if (response.ok) {
                const blob = await response.blob();
                const url = URL.createObjectURL(blob);
                
                if (isPdf) {
                    window.open(url, '_blank');
                } else {
                    setPdfUrl(url);
                }
            }
            setLoader(0);
        };
        fetchPdf()
    }

    // input text change handler
    const handleInputChange = (event) => {
        setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));
    }

    const amountFormat = (e) => {
        const value = e.target.value;
        const regex = /^\d*\.?\d*$/;
        if (!regex.test(value)) {
            // Remove invalid character if not matching
            e.target.value = value.slice(0, -1);
        }
    }

    // form submit event
    const handleSubmit = async (event) => {
        event.preventDefault();
        const formValid = simpleValidator.current.allValid()
        if (!formValid) {
            simpleValidator.current.showMessages(true);
            forceUpdate(1);
        } else {
            try {
                SetButtonDisabled(true);
                var res_data = await post(POST_ADD_EDIT_PAYMENT, form_inputs);
                if (res_data.status) {
                    toast(res_data.message);
                    $('.modal-close').click();
                    getList();
                } else {
                    toast.error(res_data.message);
                }
                SetButtonDisabled(false);

            } catch (error) {
                toast.error(error.message);
                SetButtonDisabled(false);
            }
        }
    }

    // input text change handler
    const dateChange = (date) => {
        // if (!date) return;

        // Start of month
        const startDate = new Date(date.getFullYear(), date.getMonth(), 1);

        // End of month
        const endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        filter_option.startDate = local_utc_timestamp(new Date(startDate).getTime());
        filter_option.endDate = local_utc_timestamp(new Date(endDate).getTime());
        console.log(filter_option);
        setFilterOption({ ...filter_option })
    }

    return (
        <>
            {isLoader > 0 && <Loader />}
            <div className='row'>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div className='row mb-3'>
                                <div className='col-sm-6'>
                                    <h5 className='mt-1'>{t('reports.salaryReports.title')} </h5>
                                </div>
                                <div className='col-sm-6 text-right'>
                                    {/* <Link to='/attendance/add' className='btn btn-sm btn-primary'>+ {t('add')}</Link> */}
                                </div>
                            </div>
                            <hr />

                            <div className='row mb-3'>
                                <div className='col-sm-2 mb-3'></div>
                                <div className='col-sm-3 mb-3'>
                                    <label className='form-label text-capitalize'>Start Date</label>
                                    <DatePicker
                                        name='startDate'
                                        className='form-control'
                                        selected={filter_option.startDate}
                                        onChange={dateChange}
                                        dateFormat="MM, yyyy"
                                        showMonthYearPicker
                                        onKeyDown={(e) => e.preventDefault()}
                                    />
                                </div>
                                <div className='col-sm-3 mb-3'>
                                    <label className='form-label text-capitalize'>Employees</label>
                                    <Select
                                        name='employeeId'
                                        value={employees.find(emp => emp.value === filter_option.employeeId) || null}
                                        onChange={(value) => { handleInputChangeFilter({ target: { name: 'employeeId', value: value.value } }) }}
                                        options={employees}
                                    />
                                </div>
                                <div className='col-sm-3 mb-3 pt-4'>
                                    <button type='button' onClick={getList} className='btn btn-primary me-3'>Apply</button>
                                    <button type='button' onClick={clear} className='btn btn-danger'>Clear</button>
                                </div>
                            </div>
                            <hr />

                            <div className='table-responsive text-nowrap'>
                                <table id="dataTableExample" className="table table-striped">
                                    <thead>
                                        <tr>
                                            <td>Id</td>
                                            <td>{t('reports.salaryReports.employeeId')}</td>
                                            <td>{t('reports.salaryReports.employeeName')}</td>
                                            <td>{t('reports.salaryReports.departmentName')}</td>
                                            <td>{t('reports.salaryReports.date')}</td>
                                            <td>{t('reports.salaryReports.salary')}</td>
                                            <td>{t('reports.salaryReports.overtimeSalary')}</td>
                                            <td>{t('reports.salaryReports.amount')}</td>
                                            <td>{t('reports.salaryReports.action')}</td>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <iframe title='Print' src={pdfUrl} style={{ "display": "none" }}></iframe>

            <div className="modal fade" id="deleteModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">{t('payment.form.title')}</h5>
                            <button type="button" className="btn btn-sm modal-close" data-bs-dismiss="modal" aria-label="Close">
                                <i className="bx bx-x"></i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form className="av-invalid" onSubmit={handleSubmit}>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">{t('payment.form.date')} *</label>
                                    <DatePicker name='date' className='form-control'
                                        selected={form_inputs.date} onChange={(date) => {
                                            handleInputChange({ target: { name: 'date', value: local_utc_timestamp(date) } })
                                        }}
                                        dateFormat="dd/MM/yyyy"
                                        onKeyDown={(e) => e.preventDefault()}
                                    />
                                    {simpleValidator.current.message('date', form_inputs.date, 'required', {
                                        messages: {
                                            required: t('payment.formError.date')
                                        }
                                    })}
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">{t('payment.form.employee')} *</label>
                                    <Select
                                        name='employeeId'
                                        value={employees.find(emp => emp.value === form_inputs.employeeId) || null}
                                        onChange={(value) => { handleInputChange({ target: { name: 'employeeId', value: value.value } }) }}
                                        options={employees}
                                        isDisabled={true}
                                    />
                                    {simpleValidator.current.message('name', form_inputs.employeeId, 'required', {
                                        messages: {
                                            required: t('payment.formError.employeeRequired')
                                        }
                                    })}
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">{t('payment.form.paymentType')} *</label>
                                    <select name='paymentType' className='form-control' value={form_inputs.paymentType} onChange={handleInputChange}>
                                        <option value="">{t('payment.placeholder.paymentType')}</option>
                                        <option value="Advance">Advance</option>
                                        <option value="Salary">Salary</option>
                                    </select>
                                    {simpleValidator.current.message('name', form_inputs.paymentType, 'required', {
                                        messages: {
                                            required: t('payment.formError.paymentTypeRequired')
                                        }
                                    })}
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">{t('payment.form.paymentMethod')} *</label>
                                    <select name='paymentMethod' className='form-control' value={form_inputs.paymentMethod} onChange={handleInputChange}>
                                        <option value="">{t('payment.placeholder.paymentMethod')}</option>
                                        <option value="Cash">Cash</option>
                                        <option value="Cheque">Cheque</option>
                                        <option value="Online">Online</option>
                                    </select>
                                    {simpleValidator.current.message('name', form_inputs.paymentMethod, 'required', {
                                        messages: {
                                            required: t('payment.formError.paymentTypeRequired')
                                        }
                                    })}
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">{t('payment.form.amount')} *</label>
                                    <input name="amount" value={form_inputs.amount} onKeyUp={amountFormat} onChange={handleInputChange} className="form-control" placeholder={t('payment.placeholder.amount')} type="text" maxLength={8} />
                                    {simpleValidator.current.message('amount', form_inputs.amount, 'required', {
                                        messages: {
                                            required: t('payment.formError.amountRequired')
                                        }
                                    })}
                                </div>
                                <div className='mb-3'>
                                    <label className="form-label text-capitalize">{t('payment.form.note')}</label>
                                    <textarea name="note" value={form_inputs.note} onChange={handleInputChange} className="form-control" placeholder={t('payment.placeholder.note')} />
                                </div>

                                <div className='text-center'>
                                    <button disabled={ButtonDisabled} className="btn btn-primary pt-2 pb-2">
                                        {ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} {t('save')}
                                    </button>
                                    <button data-bs-dismiss="modal" className="btn btn-danger ms-3"> {t('cancel')}</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SalaryReports;